<script setup lang="ts">
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'

  import useCourse from '@/composables/useCourse'
  import useIcons from '@/composables/useIcons'
  import useVideo from '@/composables/useVideo'
  import useCommonMixin from '@/composables/useCommonMixin'

  const { course, openWebinarModal } = useCourse()
  const { play } = useIcons()
  const { getPosterImage } = useVideo()
  const { windowOpenProxyCheck } = useCommonMixin()
</script>

<template lang="pug">
.webinar-details
  .webinar-registration
    .registration-details
      h4.ketch-font-bold {{ $t('courses.webinarDetails.registerForTheWebinar') }}
      .live-webinar
        h6 Live-Webinar
      h5 {{ $t('courses.webinarDetails.description') }}
    KetchUpButton.tertiary.ketch-w-full(
      @click.native='windowOpenProxyCheck(course?.webinar?.bookingUrl || "", "webinar")'
    )
      h4 {{ $t('courses.webinarDetails.makeAnAppointment') }}
  .webinar-info
    h4.ketch-font-bold {{ $t('courses.webinarDetails.webinar') }}
    .webinar-image(@click='openWebinarModal')
      img(:src='getPosterImage(course?.webinar?.teaserVideoUrl || "")')
      .play-overlay
        SVGRenderer(
          :icon='play',
          :stroke-color='"var(--primary-foreground-color)"',
          :has-hover='false',
          width='25px',
          height='25px'
        )
</template>

<style lang="postcss" scoped>
  .webinar-details {
    @apply ketch-flex ketch-flex-col ketch-space-y-c20 ketch-bg-content-background-color ketch-rounded-normal ketch-p-c10 ketch-shadow-content-shadow;
    @apply xs1:ketch-p-c15 sm:ketch-grid sm:ketch-grid-cols-2 sm:ketch-space-y-0 sm:ketch-bg-transparent sm:ketch-rounded-none sm:ketch-p-c20 sm:ketch-shadow-none sm:ketch-h-full;

    .webinar-registration {
      @apply ketch-flex ketch-flex-col ketch-space-y-c15 ketch-justify-between;
      @apply sm:ketch-border-r sm:ketch-border-border-color sm:ketch-pr-c20;

      .registration-details {
        @apply ketch-flex ketch-flex-col ketch-space-y-c10;

        .live-webinar {
          @apply ketch-px-c10 ketch-py-c5 ketch-bg-black ketch-rounded-[15px] ketch-w-fit;

          h6 {
            @apply ketch-text-white ketch-font-bold;
          }
        }
      }
    }

    .webinar-info {
      @apply ketch-flex ketch-flex-col ketch-space-y-c10 sm:ketch-pl-c20;

      .webinar-image {
        @apply ketch-h-full ketch-cursor-pointer ketch-relative;

        img {
          @apply ketch-w-full ketch-h-full ketch-object-cover ketch-rounded-normal;
        }
      }
    }
  }
</style>
